import { render, staticRenderFns } from "./DefaultTabs.vue?vue&type=template&id=ebdb2182&scoped=true&"
import script from "./DefaultTabs.vue?vue&type=script&lang=js&"
export * from "./DefaultTabs.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTabs.vue?vue&type=style&index=0&id=ebdb2182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdb2182",
  null
  
)

export default component.exports